// Vendor Components
import {connect} from 'react-redux';

// Actions
import {actionCreators} from 'isee/redux/session';

// Vendor Types
import {Dispatch} from 'redux';

// Types
export interface SessionTokenProps {
  resetToken: () => void;
  setToken: (userId: string, token: string) => void;
}

export const mapDispatchToProps = (
  dispatch: Dispatch<any>
): SessionTokenProps => ({
  resetToken: () => dispatch(actionCreators.resetToken()),
  setToken: (userId: string, token: string) =>
    dispatch(actionCreators.setToken(token))
});

export default connect(null, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/ui/authenticated/components/with-redux/with-redux.tsx